<div class="container">
  <div class="header">
    <h2>Service Request</h2>
  </div>
  <form>
    <div class="mb-3">
      <label for="contactName" class="form-label">On-site contact name</label>
      <input
        type="text"
        class="form-control"
        id="contactName"
        placeholder="Enter name"
      />
    </div>
    <div class="mb-3">
      <label for="contactNumber" class="form-label"
        >On-site contact phone number</label
      >
      <input
        type="tel"
        class="form-control"
        id="contactNumber"
        placeholder="Enter phone number"
      />
    </div>
    <div class="mb-3 form-check">
      <input type="checkbox" class="form-check-input" id="consentCheckbox" />
      <label class="form-check-label" for="consentCheckbox"
        >I agree to receive texts from Ecolab related to this issue</label
      >
    </div>
    <div class="mb-3">
      <label for="details" class="form-label"
        >Additional Details (optional)</label
      >
      <textarea class="form-control" id="details" rows="3"></textarea>
    </div>
    <div class="mb-3">
      <label for="uploadPhoto" class="form-label">Upload a Photo</label>
      <input class="form-control" type="file" id="uploadPhoto" multiple />
    </div>
    <button type="submit" class="btn btn-primary">Submit</button>
  </form>
</div>
